import { render } from "./AboutView.html?vue&type=template&id=c69e71f4&scoped=true&ts=true&external"
import script from "./AboutView.ts?vue&type=script&lang=ts&external"
export * from "./AboutView.ts?vue&type=script&lang=ts&external"

import "./AboutView.vue?vue&type=style&index=0&id=c69e71f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69e71f4"]])

export default __exports__